import * as React from 'react';
import { Teams } from './Teams';
import { TeamsStore } from './stores';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';

export interface ITeamsProps {
  title: string;
  tenant: string;
  token: string;
  environment?: "Development" | "Test" | "Production",
  numCards: number;
  language: "Danish" | "English" | "Swedish" | "German" | "Portuguese" | "Norwegian";
  borderColor?: string;
}

export class IATeams extends React.Component<ITeamsProps> {

  private teamsStore: TeamsStore;

  constructor(props: ITeamsProps) {
    super(props);
    this.teamsStore = new TeamsStore();
    this.teamsStore.title = props.title;
    this.teamsStore.environment = props.environment;
    this.teamsStore.tenant = props.tenant;
    this.teamsStore.token = props.token;
    this.teamsStore.numCards = props.numCards;
    this.teamsStore.language = props.language;
    this.teamsStore.borderColor = props.borderColor;
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
  }

  public componentWillReceiveProps(props: ITeamsProps): void {
    this.teamsStore.title = props.title;
    this.teamsStore.environment = props.environment;
    this.teamsStore.tenant = props.tenant;
    this.teamsStore.token = props.token;
    this.teamsStore.numCards = props.numCards;
  }


  render() {
    return (
      <Provider teamsStore={this.teamsStore}>
        <Teams />
      </Provider>
    )
  }
}
